var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDpn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5H2V9.5H10V10.5ZM2 13H7V12H2V13ZM17 16C17 18.2056 15.2056 20 13 20C10.7944 20 9 18.2056 9 16C9 13.7944 10.7944 12 13 12C15.2056 12 17 13.7944 17 16ZM16 16C16 14.3458 14.6542 13 13 13C11.3458 13 10 14.3458 10 16C10 17.6542 11.3458 19 13 19C14.6542 19 16 17.6542 16 16ZM10 7H2V8H10V7ZM10 19.9973V20H0V0H10.2269L14 4.31213V11.1006C13.6768 11.0347 13.3424 11 13 11V5H9.5V1H1V19H9.00273C9.28665 19.3773 9.62265 19.7133 10 19.9973ZM10.5 4H12.3981L10.5 1.83071V4ZM14.5 15.5V15C14.5 14.1729 13.8271 13.5 13 13.5C12.1729 13.5 11.5 14.1729 11.5 15V15.5H11V18H15V15.5H14.5ZM12.5 15C12.5 14.7243 12.7243 14.5 13 14.5C13.2757 14.5 13.5 14.7243 13.5 15V15.5H12.5V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpn);
export default __webpack_public_path__ + "static/media/dpn.86715cc2693e72694396153710097b14.svg";
export { ForwardRef as ReactComponent };